import { useAppSelector } from 'app/hooks';
import { flightActiveBookStep, flightBookSteps } from 'store/flight/flightSlice';
import { isLTRState } from 'store/options/optionsSlice';
import * as S from './flightSteps.styles';

const FlightSteps = () => {
  const steps = useAppSelector(flightBookSteps);
  const activeStep = useAppSelector(flightActiveBookStep);
  const isLTR = useAppSelector(isLTRState);

  return (
    <S.Wrapper>
      {steps.map((e, i) => {
        return (
          <S.Step
            key={e.step}
            $active={e.step === activeStep}
            $isPassed={e.step < activeStep}
            $index={i}
            $isLTR={isLTR}
          >
            {e.title}
          </S.Step>
        );
      })}
    </S.Wrapper>
  );
};
export default FlightSteps;
